import { Button, ConfirmationPopup, Icon } from '@timeedit/ui-components';
import { Space } from '@timeedit/ui-components/antd';
import './index.scss';

type TDrawerExtraButtons = {
  confirmDeleteMsg?: string;
  cancelDeleteLabel?: string;
  handleDelete?: () => void;
  handleDiscard: () => void;
  handleSave: () => void;
  handleCopy?: () => void;
  isSaveDisable: boolean;
  showDeleteAtAll?: boolean;
  isCopyDisable?: boolean;
  isDeleteDisable?: boolean;
  isDeletePopupDisable?: boolean;
  isLoading?: boolean;
  buttonSize?: 'small' | 'middle' | 'large';
};

const DrawerExtraButtons = ({
  confirmDeleteMsg = 'Are you sure you want to delete this item?',
  cancelDeleteLabel = 'Keep',
  handleDelete,
  handleDiscard,
  handleSave,
  handleCopy,
  isSaveDisable,
  showDeleteAtAll = true,
  isCopyDisable = false,
  isDeleteDisable = false,
  isDeletePopupDisable = false,
  isLoading = false,
  buttonSize = 'small',
}: TDrawerExtraButtons) => {
  return (
    <Space className="drawer-extra-buttons">
      {showDeleteAtAll && (
        <>
          {!isDeletePopupDisable && !!handleDelete && (
            <ConfirmationPopup
              message={confirmDeleteMsg}
              onConfirm={handleDelete}
              okText="Delete"
              cancelText={cancelDeleteLabel}
            >
              <Button
                disabled={isDeleteDisable}
                style={{ marginRight: 8 }}
                size={buttonSize}
                icon={<Icon id="DeleteOutlined" alt="Delete" />}
              />
            </ConfirmationPopup>
          )}
          {isDeletePopupDisable && !!handleDelete && (
            <Button
              onClick={handleDelete}
              disabled={isDeleteDisable}
              style={{ marginRight: 8 }}
              size={buttonSize}
              icon={<Icon id="DeleteOutlined" alt="Delete" />}
            />
          )}
        </>
      )}

      {handleCopy && (
        <Button
          onClick={handleCopy}
          size={buttonSize}
          disabled={isCopyDisable}
          icon={<Icon id="CopyOutlined" alt="Duplicate" />}
        >
          Duplicate
        </Button>
      )}
      <Button
        onClick={handleDiscard}
        size={buttonSize}
        disabled={isSaveDisable}
      >
        Discard
      </Button>
      <Button
        size={buttonSize}
        type="primary"
        disabled={isSaveDisable}
        onClick={handleSave}
        loading={isLoading}
      >
        Save
      </Button>
    </Space>
  );
};

export default DrawerExtraButtons;
